import MetaTags from "../../components/MetaTags";
import { QuizProvider } from "../../context/QuizContext";
import QuizPage from "../../features/web/quiz/QuizPage";

function Quiz() {
    return (
        <>
            <MetaTags
                title="مستر شريف أسامة | الامتحان"
                description="صفحة الامتحان على منصة شريف أسامة لمادة اللغة العربية للثانوية العامة. استعرض الامتحان لتحقيق التفوق الدراسي."
                image="/images/Thumbnail.webp"
                name="Mr Sherif-Osama"
            />
            <QuizProvider>
                <QuizPage />
            </QuizProvider>
        </>
    );
}

export default Quiz;
